import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findLicense = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/license?`+params,
        method: 'GET'
    })
}

export const prohibitLicense = (ids,params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/license/${ids}?`+params,
        method: 'PUT'
    })
}
